import type { FC } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import type { PinterestAdCreateResult } from '../api';

const cellSx = { fontSize: 14, whiteSpace: 'pre-wrap', wordBreak: 'break-all' } as const;

const Cell: FC<{ value: string }> = ({ value }) => (
  <TableCell align="left">
    <Typography sx={cellSx}>{value}</Typography>
  </TableCell>
);

/** Facebook result layout (Ad Account / Adset / Creative / Result / Ad ID / Message) plus Campaign. */
const PinterestJobResultTable: FC<{ rows?: PinterestAdCreateResult[] }> = ({ rows }) => (
  <TableContainer sx={{ width: '100%' }}>
    <Table sx={{ minWidth: 650 }} aria-label="Pinterest ads creation result">
      <TableHead>
        <TableRow>
          <TableCell sx={{ minWidth: 140 }}>Ad Account</TableCell>
          <TableCell sx={{ minWidth: 200 }}>Campaign</TableCell>
          <TableCell sx={{ minWidth: 200 }}>Ad group</TableCell>
          <TableCell sx={{ minWidth: 200 }}>Creative</TableCell>
          <TableCell align="center" sx={{ minWidth: 80 }}>
            Result
          </TableCell>
          <TableCell sx={{ minWidth: 140 }}>Ad ID</TableCell>
          <TableCell>Message</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows?.map((row, index) => (
          <TableRow
            key={`${index}:${row.ad_group_id}:${row.creative_name}`}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <Cell value={row.account_id} />
            <Cell value={row.campaign_name} />
            <Cell value={row.ad_group_name} />
            <Cell value={row.creative_name} />
            <TableCell align="center">{row.success ? '✅' : '❌'}</TableCell>
            <Cell value={row.ad_id} />
            <Cell value={row.message_details} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default PinterestJobResultTable;
